import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { scrollToCoords } from '../../../utils/scroll';

import { ComponentJSSClasses } from './styles';

const MENU_HEIGHT = 60;

export interface NavigationMenuProps {
    items: Array<NavigationMenuItem>;
}

export interface NavigationMenuItem {
    title: string;
    blockId: string;
}

interface NavigationMenuState {
    selectedBlockId: string | null;
    isSticky: boolean;
}

interface StyledNavigationMenuProps extends NavigationMenuProps, JSSClassesProps<ComponentJSSClasses> { }

export class NavigationMenu extends React.Component<StyledNavigationMenuProps, NavigationMenuState> {

    private containerRef = React.createRef<HTMLDivElement>();

    constructor(props: StyledNavigationMenuProps) {
        super(props);

        this.state = {
            selectedBlockId: this.props.items.length > 0 ? this.props.items[0].blockId : '',
            isSticky: false
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    }


    render() {
        if (!this.props.items.length) {
            return null;
        }

        const { classes } = this.props;

        return (
          <div className={classes.containerBlur}>
            <nav
              className={classes.container}
              ref={this.containerRef}
            >
              {this.renderMenu()}
            </nav>
          </div>
        );
    }

    private renderMenu(): JSX.Element {
        const { classes } = this.props;
        return (
            <ul className={classes.menuList}>
                {this.props.items.map((item: NavigationMenuItem) => {
                    return (
                        <li
                            className={
                                this.state.selectedBlockId === item.blockId
                                    ? classes.selectedMenuItem
                                    : classes.menuItem
                            }
                            key={item.blockId}
                        >
                            <a
                                href={`#${item.blockId}`}
                                className={classes.link}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onItemClick(item.blockId);
                                }}
                            >
                                {item.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
        );
    }

    private onScroll = () => {
        const menuOffsetTop = this.containerRef.current?.offsetTop || 0;

        if (window.pageYOffset > menuOffsetTop) {
            this.setState({ isSticky: true });
        } else {
            this.setState({ isSticky: false });
        }

         this.setState({ selectedBlockId: this.getActiveItem(Math.ceil(window.pageYOffset)) });
    }

    private getActiveItem = (windowYOffset: number): string => {
        if (this.props.items.length === 0) {
            return '';
        }
        const items = this.props.items;
        const firstBlockOffset = document.getElementById(items[0].blockId)?.offsetTop || 0;

        if (windowYOffset + MENU_HEIGHT < firstBlockOffset) {
            return items[0].blockId;
        }

        for (let i = 1; i < items.length; i++) {
            const blockOffset = document.getElementById(items[i].blockId)?.offsetTop || 0;

            if (windowYOffset + MENU_HEIGHT < blockOffset) {
                return items[i - 1].blockId;
            }
        }

        return items[items.length - 1].blockId;
    }

    private addAnchorToUrl = (blockId: string): void => {
        let currentUrl: string = window.location.href;
        if (currentUrl.includes('#')) {
            const tmp = currentUrl.split('#');
            tmp.pop();
            tmp.push(blockId);
            currentUrl = tmp.join('#');
        } else {
            currentUrl = `${currentUrl}#${blockId}`;
        }

        window.history.replaceState(null, '', currentUrl);
    }

    private onItemClick = (blockId: string) => {
        const blockOffset = document.getElementById(blockId)?.offsetTop || 0;
        this.addAnchorToUrl(blockId);
        scrollToCoords({
            pageY: (blockOffset - MENU_HEIGHT)
        }, 500);
    }
}
